import { GeneralParcelInfo } from '@lanterds/types';
import { Tooltip } from '@mui/material';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';
import WarningTwoToneIcon from '@mui/icons-material/WarningTwoTone';
import { closeSnackbar } from 'notistack';

type ParcelCodeProps = {
    parcelInfo: GeneralParcelInfo;
};

export default function ParcelCode({ parcelInfo }: ParcelCodeProps) {
    const location = useLocation();
    const isV1 = location.pathname.includes('/v1/');

    const { parcelCode, possessionDateUTC, deliveryDateUTC, dateCreated, customer, endPointInfo, deliveryLocationAlert } =
        parcelInfo;

    const queryDate = possessionDateUTC ?? deliveryDateUTC ?? dateCreated;

    const urlParamsEncoded = [
        parcelCode,
        new Date(queryDate).toISOString(),
        customer.customerId,
        endPointInfo.endPointNumber,
    ].map((params) => encodeURIComponent(params));

    const detailUrl = `${isV1 ? '/v1' : ''}/parcel/${urlParamsEncoded.join('/')}`;

    const enoughDetailToMakeDetailURL =
        !!parcelCode &&
        parcelCode.toUpperCase() !== 'NULL' &&
        !!queryDate &&
        !!customer?.customerId &&
        String(customer?.customerId).toUpperCase() !== 'NULL' &&
        !!endPointInfo?.endPointNumber &&
        endPointInfo.endPointNumber.toUpperCase() !== 'NULL';

    return (
        <>
            {deliveryLocationAlert && (
                <Tooltip arrow title="Delivery location does not match expected delivery destination." placement="top">
                    <WarningTwoToneIcon />
                </Tooltip>
            )}
            {enoughDetailToMakeDetailURL && (
                <Link to={detailUrl} state={{ from: 'parcelCode' }} onClick={() => closeSnackbar()}>
                    {parcelCode}
                </Link>
            )}
            {!enoughDetailToMakeDetailURL && (
                <>
                    <Tooltip
                        arrow
                        title="This parcel does not have enough information for us to reliably fetch details."
                        placement="top"
                    >
                        <InfoTwoToneIcon />
                    </Tooltip>{' '}
                    {parcelCode}
                </>
            )}
        </>
    );
}
